<template>
  <div id="new_guest_book">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all">
      <div class="con_box2">
        <router-link :to="{ name: 'guest_book'}">
          <button type="submit" class="gue_btn">{{showPage.back}}</button>
        </router-link>
        <div class="gue_box">
          <div class="gue_box_user">
            <table>
              <tr>
                <th>{{showPage.guestName}}</th>
                <td>
                  <input name="" type="text" class="sign_inp" v-model="book.guestName">
                </td>
              </tr>
              <tr>
                <th>Email</th>
                <td>
                  <input name="" type="text" class="sign_inp" v-model="book.guestEmail">
                </td>
              </tr>
            </table>
            <div class="gue_box_ans mb10">
              <textarea name="" cols="" rows="" class="sign_txt" placeholder="留言內容" v-model="book.guestMessage"></textarea>
            </div>
            <table>
              <tr>
                <th>{{showPage.verificationCode}}</th>
                <td class="vile">
                  <vue-recaptcha ref="recaptcha" @verify="onVerify" sitekey="6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"></vue-recaptcha>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="pagination-row text-center">
          <button type="submit" class="gue_btn" @click="sendMessage">{{showPage.leaveMessage}}</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { PostErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';
import VueRecaptcha from 'vue-recaptcha';
export default {
  name: 'new_guest_book',
  components: { VueRecaptcha },
  data() {
    return {
      book: {
        guestName: '',
        guestEmail: '',
        guestMessage: '',
        verifycode: ''
      },
      showPage: ShowPage(sessionStorage.getItem('locale')),
    };
  },

  methods: {
    onSubmit: function() {
      this.$refs.invisibleRecaptcha.execute()
    },
    onVerify: function(response) {
      this.verifycode = response
    },

    sendMessage() {

      try {
        this.checkName()
        this.checkEmail();
        this.verify()
      } catch (error) {
        alert(error.message);
        return;
      }

      let form = new FormData();

      form.append('guestName', this.book.guestName || '');
      form.append('guestEmail', this.book.guestEmail || '');
      form.append('guestMessage', this.book.guestMessage || '');
      form.append('g-recaptcha-response', this.verifycode);


      this.$Message.loading({ content: '儲存中...', duration: 0 });

      axios.post(API.message, form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          this.$Message.destroy();
          ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
          this.$router.push({ name: 'guest_book' });
        })
        .catch(error => {
          this.$Message.destroy();
          PostErrorHandler.bind(this)(error, 'message');
        });

    },
    checkName() {
      if (!this.book.guestName) {
        throw new Error('請輸入姓名');
      }
    },
    verify() {
      if (!this.verifycode) {
        throw new Error('請勾選驗證');
      }
    },
    checkEmail() {
      let regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.book.guestEmail && !this.book.guestEmail.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    },


  },
}

</script>
<style lang="scss">
#new_guest_book {
  .code {
    background-image: url(/../static/bg_1.jpg);
    font-family: Arial;
    font-style: italic;
    color: #a3a3a3;
    font-size: 22px;
    border: 0;
    padding: 2px 3px;
    letter-spacing: 3px;
    font-weight: bolder;
    cursor: pointer;
    width: 130px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    display: inline-block;
    margin-left: 10px;
  }
  .vile {
    a {
      text-decoration: none;
      font-size: 14px;
      color: #fff;
      font-weight: 500;
    }
  }
}

</style>



// WEBPACK FOOTER //
// NewGuestBook.vue?d1e6d87e